import React from 'react';
import { Loggklient } from '../klient/Loggklient';

interface IProgramContext {
	renderFeil: () => JSX.Element;
	loggklient: Loggklient;
	skjulFeil: () => void;
	visFeil: (feil: string, krasj?: boolean) => void;
	sid: string;
}

export const ProgramContext = React.createContext<IProgramContext>(({
	renderFeil: () => undefined,
} as unknown) as any);
